var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-wrap"},[_c('div',{staticClass:"body-wrap fx-fill"},[_c('div',{attrs:{"id":"map"}}),_c('div',{staticClass:"location_info fx-middle"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.address))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }